import { createContext, useContext, useState } from "react";

const DoctorContext = createContext();

export const DoctorProvider = ({ children }) => {
  const [doctorListData, setDoctorListData] = useState([]);

  return (
    <DoctorContext.Provider value={{ doctorListData, setDoctorListData }}>
      {children}
    </DoctorContext.Provider>
  );
};

// custom hook for easy usage
export const useDoctor = () => useContext(DoctorContext);
